// utils/navbarUtils.js

export const groupedMenuData = {
  m1: [
    { name: "Entity", iconName: "stars", route: "entity" },
    { name: "SM-Workflow", iconName: "flowchart", route: "statemachine" },
    { name: "Forms", iconName: "list_alt", route: "smform" },
    { name: "Templates", iconName: "collections_bookmark", route: "template" },
    { name: "App Users", iconName: "group", route: "appuser" },
    // { name: "Community Users", iconName: "communities", route: "communityuser" },
    { name: "BPNM", iconName: "rebase", route: "workflow" }
  ],
  m2: [
    { name: "Screens", iconName: "screenshot_monitor", route: "screen" },
    { name: "Blocks", iconName: "grid_view", route: "applicationblock" },
    { name: "Public Screen", iconName: "tv_signin", route: "publicaccess" }
  ],
  m3: [
    { name: "Cron Jobs", iconName: "work_history", route: "cron" },
    { name: "Jobs", iconName: "work", route: "jobs" },
    { name: "API / Webhook", iconName: "webhook", route: "api" },
    { name: "Connectors", iconName: "cable", route: "connectors" },
    { name: "Variables", iconName: "key", route: "variables" },
    { name: "Lock", iconName: "lock", route: "lock" },
    { name: "Image Repo", iconName: "photo_library", route: "imagerepo" },
    { name: "File Repo", iconName: "description", route: "filerepo" }
  ],
  m4: [
    { name: "DB connectors", iconName: "conversion_path", route: "dbconnectors" },
    { name: "RDBMS Forms", iconName: "list_alt", route: "rdbmsform" },
    { name: "RDBMS Templates", iconName: "collections_bookmark", route: "sqltemplate" }
  ]
};

export const headerModes = [
  { icon: "flowchart", title: "Workflow", mode: "m1", route: "statemachine" },
  { icon: "airplay", title: "View", mode: "m2", route: "screen" },
  { icon: "tv_options_input_settings", title: "Config", mode: "m3", route: "cron" },
  { icon: "database", title: "BYoDB", mode: "m4", route: "dbconnectors" }
];

export const getModulePath = (route, orgId, appId) => {
  return `/organization/${orgId}/app/${appId}/${route}`;
};

export const getMenuByMode = (mode) => {
  return groupedMenuData[mode] || [];
};
